import React, { useState, useEffect } from 'react';
import Button from '../components/Button';
import loginImage from '../assets/images/login.svg';
import logo from '../assets/images/logo.svg';
import '../styles/login.css';
import { loginUser } from '../api/api';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../features/auth/AuthSlice';
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../api/api';
import { useSelector } from 'react-redux';


const ChangePassword = () => {

  // State management
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({email:'', password:''});
  const [isLoading, setIsloading] = useState(false); 
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  // Extract email from URL on component mount
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search); // Get URL params
    const emailFromUrl = queryParams.get('email'); // Extract "email" param
    if (emailFromUrl) {
      setEmail(emailFromUrl); // Set email state
    }
  }, []);


  // Validation email and password
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
  }

  const validatePassword = (password) => {
    return password.length >= 5;
  }


  const loginValidate = async () => {
    let emailError = '';
    let passwordError = '';
    let confirmPasswordError = '';

  
    if (!validatePassword(password)) {
      passwordError = 'Password must be at least 6 characters long.';
    }
  
    if (password == confirmPassword) {
      confirmPasswordError = 'New password cannot be the same as the old password!.';
    }
  
    if (passwordError || confirmPasswordError) {
      setErrors({
        password: passwordError,
        confirmPassword: confirmPasswordError,
      });
    } else {
      setErrors({ password: '', confirmPassword: '' });
      setIsloading(true); // Start loading
  
      const passwordResetCall = async () => {
        const input_token = userID + 'CHANGE'; // Replace with your actual token
        const apiUrl = 'change_password'; // Replace with the actual API endpoint
  
        const dataInput = {
            login_user_id: userID,
            old_password: password,
            new_password: confirmPassword
        };
  
        try {
          const data = await authApi(input_token, dataInput, apiUrl, token);
  
          if (data && data.success) {
            await Toastmessage(data.message, true);
            navigate('/');
          } else if (data && data.message === 'Token has expired') {
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
          } else if (data === undefined) {
            await Toastmessage('No response from server', false);
          } else {
            await Toastmessage(data?.message || 'An error occurred', false);
          }
  
        } catch (error) {
          console.error("Error fetching data:", error);
          if (error.response && error.response.status === 401) {
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
          } else {
            await Toastmessage('Something went wrong', false);
          }
        }
      }
      passwordResetCall();
    }
  };
  

  return (
    <div>
      <div className="content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 d-none d-md-block">
              <img src={loginImage} alt="Image" className="img-fluid p-3" />
            </div>
            <div className="col-md-6 contents">
              <div className="row justify-content-center">
                <div className="col-md-9">
                  <div className="mb-4">
                    <img src={logo} alt="company logo" className='img-fluid p-3 d-block mx-auto'/>
                    <h3>Change Password</h3>
                  
                  </div>
                  <div>
                    <div className={`form-group last mt-4 ${password ? 'field--not-empty' : ''}`}>
                        <label htmlFor="password">Old Password</label>
                        <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} // Update password state
                        />
                    </div>
                    {errors.password && <div className="text-danger small">{errors.password}</div>}

                    <div className={`form-group last mt-4 ${confirmPassword ? 'field--not-empty' : ''}`}>
                        <label htmlFor="confirmPassword">New Password</label>
                        <input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)} // Update confirmPassword state
                        />
                    </div>
                    {errors.confirmPassword && <div className="text-danger small">{errors.confirmPassword}</div>}

                    <Button
                        label="Change Password"
                        onClick={loginValidate}
                        customClass="btn-button-padding btn-block btn-theme-button mt-4 mb-3"
                        disabled={isLoading}
                    />
                    </div>
                    <Link className='text-center d-block' to='/home'>Cancel</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
